/**
 * Boundary helper for Orval-generated request functions.
 *
 * The generated request functions return a discriminated `{ data, status }`
 * union whose error branches (400 / 401 / 403 / 404 in the OpenAPI spec) type
 * `data` as `void`, while the success `data` is the generated DTO (which can
 * differ structurally from the quality-side type — e.g. `applied_cat_score:
 * number` vs the `1|2|3|4|5` literal union). The fetch mutator throws `ApiError`
 * on a non-2xx before the data is read, so a successful response always carries
 * the body.
 *
 * `expectData` re-asserts that success shape — the contract the previous
 * `customFetch<{ data: T }>` calls (and every downstream consumer) relied on —
 * and throws if the body is missing, so an empty-body regression surfaces as an
 * error instead of silently caching `undefined`.
 */
export function expectData<T>(res: { data: unknown }): T {
  if (res.data == null) {
    throw new Error('Expected a response body but the server returned none.');
  }
  return res.data as T;
}
